import React from 'react';
import styles from './SimpleGauge.module.css';
import classnames from 'classnames';
import { random } from 'helper';
import ContentLoader from "react-content-loader";

export enum SimpleGaugeColor {
  RED, ORANGE, GREEN, YELLOW
}

type SimpleGaugeProps = {
  type:       SimpleGaugeColor;
  count:      number;
  percentage: number;
  isLoading?: boolean;
}

export const SimpleGauge: React.FC<SimpleGaugeProps> = React.memo(({type, count, percentage, isLoading}) => {
  return (
    <div className={styles.root}>
      <svg key={isLoading ? 'simple-gauge-loading': 'simple-gauge-values' } viewBox="0 0 36 36" className={classnames(
          styles.circularChart,
          { [styles.red]: !isLoading && type === SimpleGaugeColor.RED },
          { [styles.orange]: !isLoading && type === SimpleGaugeColor.ORANGE },
          { [styles.green]: !isLoading && type === SimpleGaugeColor.GREEN },
          { [styles.yellow]: !isLoading && type === SimpleGaugeColor.YELLOW },
          { [styles.gray]: isLoading },
        )}>
        <path className={styles.circleBackground}
          d="M18 2.0845
            a 15.9155 15.9155 0 0 1 0 31.831
            a 15.9155 15.9155 0 0 1 0 -31.831"
        />
        <path className={styles.circle}
          strokeDasharray={`${isLoading ? random(5, 90) : percentage}, 100`}
          d="M18 2.0845
            a 15.9155 15.9155 0 0 1 0 31.831
            a 15.9155 15.9155 0 0 1 0 -31.831"
        />
        { isLoading ?
          <ContentLoader
            height={6}
            width={'100%'}
            x={10.5}
            y={11.6}
            speed={2}
          >
            <rect className={styles.countLoadingBar} x="0" y="0" rx="1" ry="1" width="15" height="5.5" />
          </ContentLoader>
          :
          <text x="18" y="17" className={styles.count}>{count}</text>
        }
        <rect className={styles.line} x="8" y="19" width="20" height="0.1"/>
        { isLoading ?
          <ContentLoader
            height={6}
            width={'100%'}
            x={13.4}
            y={21.4}
            speed={2}
          >
            <rect className={styles.percentLoadingBar} x="0" y="0" rx="1" ry="1" width="9" height="5" />
          </ContentLoader>
           :
          <text x="18.5" y="25" className={styles.percentage}>{`${percentage}%`}</text>
        }
      </svg>
    </div>
  );
});
